import React, { useCallback, useMemo } from 'react';
import { MusicListItemDto } from '~/models/music/music.dto';
import { useAppRoute } from '~/utils/hooks/useAppRoute';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useThunkDispatch } from '~/utils/hooks/useThunkDispatch';
import { MusicApi } from '~/api/music.api';
import css from '~/features/dashboard/components/songs-list/styles.module.scss';
import { VerticalPopver } from '~/features/dashboard/components/vertical-popover';
import { DownloadButton } from '~/common/download-button';
import {isSongFormEditing} from "~/features/dashboard/store/actions";

export const ActionsCell: React.FC<{ data: MusicListItemDto }> = ({ data }) => {
    const route = useAppRoute();
    const match = useRouteMatch<{ creatorId: string }>();
    const history = useHistory();
    const soundDetailsRoute = useMemo(() => `${match.url}/${data.assetCode}/details`, [match.url, data.assetCode]);
    const goToSoundDetails = useCallback(() => route(soundDetailsRoute), [soundDetailsRoute, route]);
    const dispatch = useThunkDispatch();
    // const editDealForm = useCallback(() => {
    //     dispatch(goToEditSongThunk({ assetCode: data.assetCode }));
    // }, [data.assetCode, dispatch]);
    const editDealForm = useCallback(() => {
        dispatch(isSongFormEditing(true));
        history.push({
            pathname: `/creators-list/${match.params.creatorId}/dashboard/songs/add-song/${data.assetCode}`,
            state: {
                gotoStep: '',
            },
        });
        // dispatch(push({ pathname: `/creators-list/${match.params.creatorId}/dashboard/songs/add-song/${data.assetCode}` }))
    }, [data.assetCode, dispatch]); // eslint-disable-line
    const handleDownloadClick = async (id: any) => {
        MusicApi.exportMusicDetails(id).then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'].split('; ')[0] }));
            const link = document.createElement('a');
            link.href = url;
            link.target = '_blank';
            link.download = 'download.zip';
            link.click();
            window.URL.revokeObjectURL(url);
            link.remove();
        });
    };
    return (
        <div className={css.actionsCell}>
            {/* <IconButton onClick={goToSoundDetails} color={'inherit'} className={classNames(css.iconColor, css.iconBg)}>
                <VisibilityOutlinedIcon color={'inherit'} className={classNames(css.colorYellow)} />
            </IconButton>
            <IconButton onClick={editDealForm} color={'inherit'} className={classNames(css.iconColor, css.marginH, css.iconBg)}>
                <EditOutlinedIcon color={'inherit'} />
            </IconButton> */}

            <VerticalPopver childClassName={''} actionsList={`edit,view`} onClickEdit={() => editDealForm()} onClickView={() => goToSoundDetails()} />

            <DownloadButton onClick={() => handleDownloadClick(data.assetCode)} className={css.downloadButton} />
        </div>
    );
};
